import { createContext, useContext, useEffect, useState, useCallback } from 'react'
import api, { setToken, getToken } from '@/lib/api'
import log from '@/lib/logger'
import { limparSessionState } from '@/lib/useSessionState'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  const loadMe = useCallback(async () => {
    if (!getToken()) {
      log.info('auth', 'Nenhum token armazenado — sessão anônima')
      setLoading(false)
      return
    }
    log.info('auth', 'Token encontrado — validando em GET /auth/me')
    try {
      const { data } = await api.get('/auth/me')
      log.info('auth', 'Sessão restaurada', { usuarioID: data?.usuarioID, nome: data?.nome })
      setUser(data)
    } catch (err) {
      log.warn('auth', 'Token inválido/expirado — limpando sessão', {
        status: err?.response?.status,
        erro: err?.response?.data?.error ?? err?.message,
      })
      setToken(null)
      setUser(null)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    loadMe()
  }, [loadMe])

  const login = useCallback(async (email, senha) => {
    log.info('auth', 'POST /auth/login', { identificador: email })
    try {
    console.log("🚀 ~ email, senha:", email, senha)
      const { data } = await api.post('/auth/login', { email, senha })
      console.log("🚀 ~ api:", api)
      console.log("🚀 ~ data:", data)

      if (!data?.token) {
        log.error('auth', 'Login respondeu 200 mas sem token no corpo', data)
        throw new Error('Resposta de login inválida (sem token).')
      }

      setToken(data.token)
      setUser(data.user)
      log.info('auth', 'Login efetuado', { usuarioID: data.user?.usuarioID, nome: data.user?.nome })
      return data.user
    } catch (err) {
      log.error('auth', 'Falha no login', {
        status: err?.response?.status,
        erro: err?.response?.data?.error ?? err?.message,
        requestId: err?.response?.headers?.['x-request-id'],
      })
      throw err
    }
  }, [])

  const logout = useCallback(() => {
    log.info('auth', 'Logout solicitado')
    setToken(null)
    setUser(null)
    limparSessionState()
    window.location.href = '/login'
  }, [])

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth deve ser usado dentro de AuthProvider')
  return ctx
}
